import { render, staticRenderFns } from "./storeDeal.vue?vue&type=template&id=4dc96c18&scoped=true&"
import script from "./storeDeal.vue?vue&type=script&lang=js&"
export * from "./storeDeal.vue?vue&type=script&lang=js&"
import style0 from "./storeDeal.vue?vue&type=style&index=0&id=4dc96c18&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc96c18",
  null
  
)

export default component.exports